import DateOfBirth from '../../components/DateOfBirth';

const DateOfBirthQuestion = ({ field }: { field: { mm: any } }) => {
    const handleMonthSelectChange = (month: any) => {
        const val = (month && month.value) || '';
        field.mm.onChange(val);
    };

    return (
        <DateOfBirth
            // @ts-expect-error
            dob={field}
            handleMonthSelectChange={handleMonthSelectChange}
        />
    );
};

export default DateOfBirthQuestion;
